module.exports = __webpack_public_path__ + "img/xy.df090a44.jpg";